import { StyleSheet, Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

/** Clips scaled media; overlay stays outside this tree so labels don't zoom. */
export const exploreMediaZoomStyles = StyleSheet.create({
  clip: {
    ...StyleSheet.absoluteFillObject,
    overflow: 'hidden',
  },
  zoom: {
    ...StyleSheet.absoluteFillObject,
    ...(isWeb ? { transition: 'transform 0.3s ease', transformOrigin: 'center center' } : {}),
  },
  zoomHovered: {
    transform: [{ scale: 1.05 }],
  },
});
